import { videoErrorTunnel } from "../../constants/tunnels";

export default function VideoErrorModal({ message, onClose }) {
  return (
    <videoErrorTunnel.In>
      <div
        style={{
          width: "80vw",
          maxWidth: "500px",
          transform: "translate(-50%, -50%)",
          zIndex: 10000000,
          top: "50%",
          left: "50%",
          position: "absolute",
          background: "white",
          border: "3px solid #000000",
          padding: "20px 30px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
          textAlign: "center",
          fontFamily: "DM Mono, monospace",
          fontSize: "24px",
        }}
      >
        <p style={{ color: "black" }}>{message}</p>
        <div
          style={{
            marginTop: "15px",
            fontSize: "20px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "6px 12px",
              backgroundColor: "#26EF96",
              color: "black",
              border: "none",
              cursor: "pointer",
              width: "40%",
              minWidth: "fit-content",
            }}
          >
            OK
          </button>
        </div>
      </div>
    </videoErrorTunnel.In>
  );
}
